"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.todayZeroTime = exports.mapDateToZeroTime = exports.mapToOutputDateRange = exports.mapToInputDateRange = exports.mapToInputDateTime = exports.parseOutputDateTime = exports.parseInputDateRange = exports.parseInputDateTime = exports.parseInputTime = exports.parseInputDate = exports.standardizeInputDateRange = exports.standardizeInputDateTime = exports.standardizeInputTime = exports.standardizeInputDate = exports.toInputDateString = void 0;
const moment_1 = __importDefault(require("moment"));
const dateTimeFormat_1 = require("../dateTimeFormat");
const validation_1 = require("./validation");
const toInputDateString = (value) => (value ? (0, moment_1.default)(value, dateTimeFormat_1.DATE_OUTPUT_FORMAT).format(dateTimeFormat_1.DATE_FORMAT) : undefined);
exports.toInputDateString = toInputDateString;
/** ToDo: Maybe exists moment or common js functions? */
const standardizeInputDate = (value) => {
    var _a, _b;
    if (!value)
        return '';
    let result = value;
    if ((_a = /^[0-9]\./.exec(result)) === null || _a === void 0 ? void 0 : _a.length) {
        result = `0${result}`;
    }
    if ((_b = /^[0-9]{2}\.[0-9]\./.exec(result)) === null || _b === void 0 ? void 0 : _b.length) {
        result = `${result.slice(0, 3)}0${result.slice(3)}`;
    }
    return result;
};
exports.standardizeInputDate = standardizeInputDate;
const standardizeInputTime = (value) => {
    var _a, _b;
    if (!value)
        return '';
    let result = value;
    if ((_a = /^[0-9]:/.exec(result)) === null || _a === void 0 ? void 0 : _a.length) {
        result = `0${result}`;
    }
    if ((_b = /^[0-9]{2}:[0-9]$/.exec(result)) === null || _b === void 0 ? void 0 : _b.length) {
        result = `${result.slice(0, 3)}0${result.slice(3)}`;
    }
    return result;
};
exports.standardizeInputTime = standardizeInputTime;
const standardizeInputDateTime = (value) => ({
    date: (0, exports.standardizeInputDate)(value.date),
    time: (0, exports.standardizeInputTime)(value.time),
});
exports.standardizeInputDateTime = standardizeInputDateTime;
const standardizeInputDateRange = (value) => ({
    from: (0, exports.standardizeInputDate)(value.from),
    to: (0, exports.standardizeInputDate)(value.to),
});
exports.standardizeInputDateRange = standardizeInputDateRange;
const parseInputDate = (value) => {
    const standardValue = (0, exports.standardizeInputDate)(value);
    const isValid = (0, validation_1.checkFormat)(standardValue, dateTimeFormat_1.DATE_FORMAT);
    if (!isValid)
        return undefined;
    return (0, moment_1.default)(standardValue, dateTimeFormat_1.DATE_FORMAT);
};
exports.parseInputDate = parseInputDate;
const parseInputTime = (value) => {
    const standardValue = (0, exports.standardizeInputTime)(value);
    const isValid = (0, validation_1.checkFormat)(standardValue, dateTimeFormat_1.TIME_FORMAT);
    if (!isValid)
        return undefined;
    const dateTime = (0, moment_1.default)(standardValue, dateTimeFormat_1.TIME_FORMAT).toDate();
    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    return {
        hours,
        minutes,
    };
};
exports.parseInputTime = parseInputTime;
const parseInputDateTime = (dateTime) => {
    const date = (0, exports.parseInputDate)(dateTime.date);
    const time = (0, exports.parseInputTime)(dateTime.time);
    if (!date || !time)
        return undefined;
    date.set('hour', time.hours);
    date.set('minute', time.minutes);
    return date;
};
exports.parseInputDateTime = parseInputDateTime;
const parseInputDateRange = (dateRange) => {
    const result = {
        from: (0, exports.parseInputDate)(dateRange.from),
        to: (0, exports.parseInputDate)(dateRange.to),
    };
    return result;
};
exports.parseInputDateRange = parseInputDateRange;
const parseOutputDateTime = (value) => (value ? (0, moment_1.default)(value, dateTimeFormat_1.DATETIME_OUTPUT_FORMAT) : undefined);
exports.parseOutputDateTime = parseOutputDateTime;
const mapToInputDateTime = (value) => {
    var _a, _b;
    return ({
        date: (_a = (0, exports.parseOutputDateTime)(value)) === null || _a === void 0 ? void 0 : _a.format(dateTimeFormat_1.DATE_FORMAT),
        time: (_b = (0, exports.parseOutputDateTime)(value)) === null || _b === void 0 ? void 0 : _b.format(dateTimeFormat_1.TIME_FORMAT),
    });
};
exports.mapToInputDateTime = mapToInputDateTime;
const mapToInputDateRange = (value) => {
    var _a, _b;
    return ({
        from: (_a = (0, exports.parseOutputDateTime)(value.from)) === null || _a === void 0 ? void 0 : _a.format(dateTimeFormat_1.DATE_FORMAT),
        to: (_b = (0, exports.parseOutputDateTime)(value.to)) === null || _b === void 0 ? void 0 : _b.format(dateTimeFormat_1.DATE_FORMAT),
    });
};
exports.mapToInputDateRange = mapToInputDateRange;
const mapToOutputDateRange = (value) => {
    var _a, _b;
    return ({
        from: (_a = (0, exports.parseInputDate)(value.from)) === null || _a === void 0 ? void 0 : _a.format(dateTimeFormat_1.DATE_OUTPUT_FORMAT),
        to: (_b = (0, exports.parseInputDate)(value.to)) === null || _b === void 0 ? void 0 : _b.format(dateTimeFormat_1.DATE_OUTPUT_FORMAT),
    });
};
exports.mapToOutputDateRange = mapToOutputDateRange;
const mapDateToZeroTime = (date) => {
    const value = new Date(date.getTime());
    value.setHours(0);
    value.setMinutes(0);
    value.setSeconds(0);
    value.setMilliseconds(0);
    return value;
};
exports.mapDateToZeroTime = mapDateToZeroTime;
const todayZeroTime = () => {
    const today = new Date();
    return (0, exports.mapDateToZeroTime)(today);
};
exports.todayZeroTime = todayZeroTime;
//# sourceMappingURL=format.js.map